import { type CVEditingSection, type FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';
import { isNotEmpty } from '../../../utils/is-not-empty';

interface LanguagesSectionProps {
  languages: FullCV['languages'];
  onEdit?: (section: CVEditingSection) => void;
}

export default function LanguagesSection({ languages, onEdit }: LanguagesSectionProps) {
  const { t } = useCVTranslation();
  const editable = onEdit !== undefined;

  if (!languages?.length && !editable) return null;

  const handleEdit = () => {
    if (onEdit) onEdit('languages');
  };

  return (
    <EditableSection onEdit={handleEdit} editable={editable} splitable>
      <div>
        <h2 className="text-[11px] font-black uppercase tracking-widest text-current pb-1.5 mb-1.5">
          {t('CV.languages')}
        </h2>
        {languages
          .filter(lang => isNotEmpty(lang.language))
          .map((lang, index) => (
            <div
              key={index}
              className="text-[11px] font-semibold text-current mb-1 uppercase tracking-wide leading-relaxed"
            >
              {(lang.language ?? '').toUpperCase()}
              {isNotEmpty(lang.level) && (
                <span className="font-normal opacity-80 text-current ml-1.5">— {lang.level}</span>
              )}
            </div>
          ))}
      </div>
    </EditableSection>
  );
}
